export const styles = {
  wrapper: {
    maxHeight: '100%',
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '15px',
    marginTop: 'auto',
  },
  message: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    lineHeight: '19px',
    color: '#555555',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/Chat/ChatWindow/style.js